import { render, staticRenderFns } from "./luckdrawlist_new.vue?vue&type=template&id=4af0c5b1&scoped=true&"
import script from "./luckdrawlist_new.vue?vue&type=script&lang=js&"
export * from "./luckdrawlist_new.vue?vue&type=script&lang=js&"
import style0 from "./luckdrawlist_new.vue?vue&type=style&index=0&lang=css&"
import style1 from "./luckdrawlist_new.vue?vue&type=style&index=1&id=4af0c5b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af0c5b1",
  null
  
)

export default component.exports